





















import gql from 'graphql-tag';
import Vue from 'vue';

interface User {
  id: string;
  name: string;
}

const query = gql`
  query {
    users: listUser(role: "auditor", offset: 0, limit: 100) {
      id
      name
    }
  }
`;

export default Vue.extend({
  props: {
    value: String as () => string | null,
  },

  data() {
    return {
      users: [],
    };
  },

  apollo: {
    users: {
      query,
      fetchPolicy: 'cache-first',
    },
  },

  methods: {
    filterOption(input: string, option: any) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    handleChange(val: string) {
      this.$emit('change', val);
      this.$emit('input', val);
    },
  },
});
